import _ from "lodash";

import NoPrint from "components/NoPrint";
import Stack from "components/Stack";

import MemoSectionContextButton from "entities/Memo/components/Sections/ContextButton";
import NASection from "entities/Memo/components/Sections/NASection";
import NoProformaUploaded from "entities/Memo/components/Sections/NoProformaUploaded";
import SectionSummary from "entities/Memo/components/Sections/Summary";
import { IMemoSection } from "entities/Memo/sdk";
import { useProformaForDealManager } from "entities/Memo/utils";
import ProformaDevelopmentBudget from "entities/Proforma/components/ProformaDevelopmentBudget";

interface ISectionDevelopmentBudget {
  dealId: number;
  externalToken?: string;
  section?: IMemoSection;
  onUpdate?: () => void;
}

const SectionDevelopmentBudget: React.FC<ISectionDevelopmentBudget> = ({
  dealId,
  externalToken,
  section,
  onUpdate,
}) => {
  const { data: proforma } = useProformaForDealManager({
    dealId,
    token: externalToken,
  });

  return (
    <>
      {proforma ? (
        <Stack spacing={2} data-testid="development-budget-section">
          {section && _.isUndefined(externalToken) && (
            <NoPrint
              sx={{
                alignSelf: "flex-end",
              }}
            >
              <MemoSectionContextButton
                dealId={dealId}
                section={section}
                onUpdate={onUpdate}
              />
            </NoPrint>
          )}
          {section?.is_na ? (
            <NASection />
          ) : (
            <Stack justifyContent="space-between" spacing={4}>
              <ProformaDevelopmentBudget proforma={proforma} />
              <SectionSummary
                title="Development budget description"
                category="Development Descriptions"
                dealId={dealId}
                externalToken={externalToken}
              />
            </Stack>
          )}
        </Stack>
      ) : (
        <NoProformaUploaded title="Development budget" />
      )}
    </>
  );
};

export default SectionDevelopmentBudget;
